import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InboxBackService {
  private url: string = null;
  private tab: number = null;
  private _isGridView: boolean;
  get isGridView() {
    return this._isGridView;
  }
  set isGridView(value) {
    this._isGridView = value;
  }

  constructor() {}

  setTab(tab: number) {
    this.tab = tab;
  }

  getUrl() {
    return this.url;
  }

  getTab() {
    return this.tab;
  }
}
